/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropLiveStatusPerPlatform
 */
export interface DropLiveStatusPerPlatform {
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusPerPlatform
     */
    platform: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropLiveStatusPerPlatform
     */
    isLive: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropLiveStatusPerPlatform
     */
    viewerCount: number;
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusPerPlatform
     */
    streamTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusPerPlatform
     */
    gameName?: string;
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusPerPlatform
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DropLiveStatusPerPlatform
     */
    embedId: string;
}

/**
 * Check if a given object implements the DropLiveStatusPerPlatform interface.
 */
export function instanceOfDropLiveStatusPerPlatform(value: object): value is DropLiveStatusPerPlatform {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('isLive' in value) || value['isLive'] === undefined) return false;
    if (!('viewerCount' in value) || value['viewerCount'] === undefined) return false;
    if (!('embedId' in value) || value['embedId'] === undefined) return false;
    return true;
}

export function DropLiveStatusPerPlatformFromJSON(json: any): DropLiveStatusPerPlatform {
    return DropLiveStatusPerPlatformFromJSONTyped(json, false);
}

export function DropLiveStatusPerPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropLiveStatusPerPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'isLive': json['isLive'],
        'viewerCount': json['viewerCount'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'embedId': json['embedId'],
    };
}

export function DropLiveStatusPerPlatformToJSON(json: any): DropLiveStatusPerPlatform {
    return DropLiveStatusPerPlatformToJSONTyped(json, false);
}

export function DropLiveStatusPerPlatformToJSONTyped(value?: DropLiveStatusPerPlatform | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'isLive': value['isLive'],
        'viewerCount': value['viewerCount'],
        'streamTitle': value['streamTitle'],
        'gameName': value['gameName'],
        'startedAt': value['startedAt'],
        'embedId': value['embedId'],
    };
}

